import React, { memo } from 'react';
import { Field } from 'react-final-form';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';

const UiInput = memo((props) => {
	const { label, name, type, placeholder, multiline, maxRows ,minRows, allowedCharacters  } = props;

	const [showPassword, setShowPassword] = React.useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};
	return (
		<Field
			name={props.name}
			render={({ input, meta }) => {
				return (
					<>
						<FormControl
							error={meta.error}
							sx={{ mb: 2 }}
							variant="outlined"
							fullWidth
						>
							<InputLabel htmlFor={name}>{label}</InputLabel>
							{type == 'password' ? (
								<OutlinedInput
									{...input}
									{...props}
									type={showPassword ? 'text' : 'password'}
									endAdornment={
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={handleClickShowPassword}
												onMouseDown={handleMouseDownPassword}
												edge="end"
											>
												{showPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									}
									label={label}
								/>
							) : (
								<OutlinedInput
									{...input}
									{...props}
									type={type}
									label={label}
                                    placeholder={placeholder}
                                    multiline={multiline}
                                    maxRows={maxRows}
                                    minRows={minRows}
									inputProps={{
										onChange: (event) => {
											if(allowedCharacters !== undefined){
												const input = event.target.value;
        										event.target.value = input.replace(/[^a-zA-Z0-9_]/g, '');
											}
										}
									}}
								/>
							)}

							{meta.error && (
								<FormHelperText className="component-error-text">
									{meta.error}
								</FormHelperText>
							)}
						</FormControl>
					</>
				);
			}}
		/>
	);
});

export default UiInput;
